import React from 'react';
import './../index.css';
import logo from './../images/alliance_logo2.png';

export class LevelTitle extends React.Component {

  render() {

    const title = this.props.title;
    return (
      <>
        {
          /*
          * Title section
          */
        }
                  <div className='banner'>
                    <div className='title'>
                      <h2>
                        {title}
                      </h2>
                      <a href='http://www.fatherlessepidemic.org/' rel='noreferrer' target='_blank'><img alt='missing' className="logo" src={logo} /></a>
                    </div>
                  </div>

      </>
    );
  }


}
